/**
 * Focus an accessible error summary or the first invalid field after validation fails.
 * Scrolls the target into view so it is visible on small screens.
 */
export function focusFormError(
  summaryId = 'register-form-errors',
  container?: ParentNode | null
): void {
  const root = container ?? document;
  const summary = document.getElementById(summaryId);
  if (summary) {
    summary.setAttribute('tabindex', '-1');
    summary.focus({ preventScroll: true });
    summary.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    return;
  }

  const invalid = (root as Document | Element).querySelector?.(
    '[aria-invalid="true"]'
  ) as HTMLElement | null;
  if (invalid) {
    invalid.focus({ preventScroll: true });
    invalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
